import React from 'react';
import {
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  taskParameters: {
    border: '1px dashed',
    padding: '25px 10px 0px 10px',
    position: 'relative',
    // marginBottom: "15px",
    borderRadius: '4px',
  },
}));
function FormFielsSet({fieldSetLabel = '', classes, children}) {
  const componentClasses = useStyles();
  return (
    <Grid item xs={12} className="p-3">
      <div className={`${componentClasses.taskParameters}`}>
        <Typography variant="h4" className={classes.legend}>
          {fieldSetLabel}
        </Typography>
        {children}
      </div>
    </Grid>
  );
}

export default FormFielsSet;
